const H3Icon = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6.823 8.33325H12.7605C12.8464 8.33325 12.9167 8.40356 12.9167 8.4895V10.677C12.9167 10.7629 12.8464 10.8333 12.7605 10.8333H11.823C11.7371 10.8333 11.6667 10.7629 11.6667 10.677V9.58325H10.4949V15.8333H11.3933C11.4792 15.8333 11.5496 15.9036 11.5496 15.9895V16.927C11.5496 17.0129 11.4792 17.0833 11.3933 17.0833H8.19019C8.10425 17.0833 8.03394 17.0129 8.03394 16.927V15.9895C8.03394 15.9036 8.10425 15.8333 8.19019 15.8333H9.08862V9.58325H7.91675V10.677C7.91675 10.7629 7.84644 10.8333 7.7605 10.8333H6.823C6.73706 10.8333 6.66675 10.7629 6.66675 10.677V8.4895C6.66675 8.40356 6.73706 8.33325 6.823 8.33325Z'
      fill='#818181'
    />
  </svg>
);

export default H3Icon;
